export default function sortArray (arr, oldIndex, newIndex) {
  const el = arr[oldIndex]
  arr.splice(oldIndex, 1)
  arr.splice(newIndex, 0, el)
  return arr
}
